import {Event} from './event.model';
import {RegisteredProgram} from './registered-program.model';

export class Program {
    id: number;
    programType: string;
    comment: string;
    abbreviation: string;
    idYellowBox: number;

    listOfEvent: Event[];
    listOfRegisteredProgram: RegisteredProgram[];
}
